import { RetryPromiseBase } from './RetryPromiseBase';
import { HttpStatus } from '@/constants';

const logErrorToConsole = (message, error, className = '', details = {}) => {
  console.error(`${className}: ${message}`, error, details);
};

// Allows us to log errors to console if logging externally fails
export class RetryPromiseWithBackoffAndFallbackLogging extends RetryPromiseBase {
  constructor(httpCodesToFailImmediately = [HttpStatus.BAD_REQUEST]) {
    super(logErrorToConsole, httpCodesToFailImmediately);
  }
}
